import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";

import { environment } from "src/environments/environment";
import { Observable, combineLatest } from "rxjs";
import { startWith, map } from "rxjs/operators";
import { Sale } from "../models/sale";
import { SalesStoreService } from "../services/sales-store.service";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-synchronized-sales",
  templateUrl: "./synchronized-sales.component.html",
  styleUrls: ["./synchronized-sales.component.scss"],
})
export class SynchronizedSalesComponent implements OnInit {
  env;
  page = 1;
  pageSize = 10;
  collectionSize = 0;

  sales: Sale[] = [];
  sales$: Observable<Sale[]>;
  filter = new FormControl("");

  constructor(private salesStore: SalesStoreService, public router: Router) {
    this.env = environment;
  }

  ngOnInit() {
    this.getSales();
  }

  getSales() {
    const filter$ = this.filter.valueChanges.pipe(startWith(""));
    const synchronizedSales$ = this.salesStore.synchronizedSales$;

    this.sales$ = combineLatest([filter$, synchronizedSales$]).pipe(map(([text, sales]) => this.search(text, sales)));
  }

  search(text: string, sales: Sale[]): Sale[] {
    console.log(text);
    const salesFiltered: Sale[] = sales.filter(sale => {
      const term = text.toLowerCase();
      const datePipe = new DatePipe("pt");

      return (
        (sale.data_da_criacao_app &&
          datePipe.transform(sale.data_da_criacao_app, "dd/MM/yyyy HH:mm:ss").includes(term)) ||
        (sale.plano.descricao && sale.plano.descricao.toLowerCase().includes(term)) ||
        (sale.titular.nome && sale.titular.nome.toLowerCase().includes(term)) ||
        (sale.titular.cpfcnpj && sale.titular.cpfcnpj.toLowerCase().includes(term)) ||
        (sale.valor_total && sale.valor_total.toString().includes(term)) ||
        (sale.vendedor.nome && sale.vendedor.nome.toLowerCase().includes(term)) ||
        (sale.processamento_erp &&
          sale.processamento_erp.status &&
          sale.processamento_erp.status.toLowerCase().includes(term))
      );
    });

    this.page = 1;
    this.collectionSize = salesFiltered.length;

    return salesFiltered;
  }

  getSaleDescription(sale): string {
    const keys = Object.keys(sale.plano);
    if (keys.includes("descricao")) {
      return sale.plano.descricao;
    }
    return sale.plano.nome;
  }
}
